import React, { useState, useEffect } from 'react';
import ModernLayout from '../components/modern_layout';
import ModernLoader from '../components/modern_loader';
import { useGlobalToast } from '../components/modern_toast';
import usePageTitle from '../hooks/usePageTitle';
import api from "../services/api";

function ModernPedidosLoja() {
  usePageTitle('Pedidos da Loja');
  // ... (outros estados)
  const [loading, setLoading] = useState(true);
  const [pedidos, setPedidos] = useState([]);
  const [statusFiltros, setStatusFiltros] = useState(['aguardando']);
  const [mostrarTodos, setMostrarTodos] = useState(false);
  const [modalAberta, setModalAberta] = useState(false);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [produtosPedido, setProdutosPedido] = useState([]);
  const [enderecoPedido, setEnderecoPedido] = useState([]);
  const [carregandoProdutos, setCarregandoProdutos] = useState(false);
  const [carregandoEndereco, setCarregandoEndereco] = useState(false);
  const { addToast } = useGlobalToast();

  const statusOptions = ['aguardando', 'processando', 'concluido', 'enviado', 'cancelado'];

  // NOVO: Lista para a legenda, para evitar duplicatas de cor (Concluído)
  const legendaItens = [
    { status: 'aguardando', label: 'Aguardando' },
    { status: 'processando', label: 'Processando' },
    { status: 'enviado', label: 'Enviado' },
    { status: 'cancelado', label: 'Cancelado' },
    { status: 'concluido', label: 'Concluído' } // 'concluido' têm a msm cor
  ];


  // ... (useEffect de carregamento, useEffect de sincronia, e outras funções como recarregarPedidos, atualizarStatusPedido, etc. permanecem iguais)
  // ... (useEffect original)
  useEffect(() => {
    const loadPedidos = async () => {
      try {
        setLoading(true);
        const id_loja = sessionStorage['loja'];
        
        const requestData = {
          'id_loja': id_loja,
          'status_filtros': statusFiltros,
          'mostrar_todos': mostrarTodos, 
          'query_start': 0,
          'query_end': 50
        };
        const response = await api.post('buscar_pedidos_loja_filtrados', requestData);
        if (response && response.data && response.data.data !== false) {
          setPedidos(response.data.data);
        } else {
          setPedidos([]);
        }
      } catch (error) {
        console.error('Erro ao carregar pedidos:', error);
        addToast('Erro ao carregar pedidos', 'error');
        setPedidos([]);
      } finally {
        setLoading(false);
      }
    };
    const inicializar = async () => {
      if (!sessionStorage['login']) {
        sessionStorage['login'] = 'test/franqueado';
      }
      if (!sessionStorage['loja']) {
        sessionStorage['loja'] = '1';
      }
      await loadPedidos();
    };
    inicializar();
  }, [statusFiltros, mostrarTodos, addToast]);

  // ... (useEffect de sincronia)
  useEffect(() => {
    const allSelected = statusOptions.length === statusFiltros.length && statusOptions.every(opt => statusFiltros.includes(opt));
    if (mostrarTodos !== allSelected) {
      setMostrarTodos(allSelected);
    }
  }, [statusFiltros, mostrarTodos, statusOptions]);

  // ... (recarregarPedidos)
  const recarregarPedidos = async () => {
    try {
      setLoading(true);
      const id_loja = sessionStorage['loja'];
      const response = await api.post('buscar_pedidos_loja_filtrados', {
        'id_loja': id_loja,
        'status_filtros': statusFiltros,
        'mostrar_todos': mostrarTodos,
        'query_start': 0,
        'query_end': 50
      });
      if (response && response.data && response.data.data !== false) {
        setPedidos(response.data.data);
      } else {
        setPedidos([]);
      }
    } catch (error) {
      console.error('Erro ao carregar pedidos:', error);
      addToast('Erro ao carregar pedidos', 'error');
      setPedidos([]);
    } finally {
      setLoading(false);
    }
  };

  // ... (atualizarStatusPedido)
  const atualizarStatusPedido = async (pedidoId, novoStatus) => {
    try {
      const response = await api.post('atualizar_status_pedido', {
        'pedido_id': pedidoId,
        'novo_status': novoStatus,
        'id_loja': sessionStorage['loja']
      });
      if (response && response.data && response.data.success) {
        addToast('Status atualizado com sucesso!', 'success');
        await recarregarPedidos();
      } else {
        addToast('Erro ao atualizar status', 'error');
      }
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      addToast('Erro ao atualizar status', 'error');
    }
  };

  // ... (carregarProdutosPedido)
  // MODIFICADO: Adicionada verificação 'Array.isArray' para segurança
  const carregarProdutosPedido = async (pedidoId) => {
    console.log('🔍 [DEBUG] carregarProdutosPedido chamado com pedidoId:', pedidoId);
    try {
      setCarregandoProdutos(true);
      setProdutosPedido([]); // Começa limpo
      const response = await api.post('buscar_produtos_pedido', {
        'pedido_id': pedidoId,
        'id_loja': sessionStorage['loja']
      });
      console.log('Resposta produtos:', response);
      
      // Verifica se 'response.data.produtos' existe E é um array
      if (response && response.data && Array.isArray(response.data.produtos)) {
        console.log('🔍 [DEBUG] Resposta da API para produtos do pedido:', response.data.produtos);
        setProdutosPedido(response.data.produtos);
      } else {
        console.warn('API [buscar_produtos_pedido] não retornou um array em .produtos');
        setProdutosPedido([]); // Garante que seja um array vazio
      }
    } catch (error) {
      console.error('Erro ao carregar produtos do pedido:', error);
      addToast('Erro ao carregar produtos', 'error');
      setProdutosPedido([]);
    } finally {
      setCarregandoProdutos(false);
    }
  };

  // MODIFICADO: Adicionada verificação 'Array.isArray' para segurança
  const carregarEnderecoPedido = async (pedidoId) => {
    console.log('🔍 [DEBUG] carregarEnderecoPedido chamado com pedidoId:', pedidoId);
    try {
      setCarregandoEndereco(true);
      setEnderecoPedido([]); // Começa limpo
      const response = await api.post('buscar_endereco_pedido', {
        'pedido_id': pedidoId,
        'id_loja': sessionStorage['loja']
      });
      console.log('Resposta endereço:', response);
      
      // Verifica se 'response.data.data' existe (pode ser um objeto, não array)
      if (response && response.data && response.data.data) {
        console.log('🔍 [DEBUG] Resposta da API para endereço do pedido:', response.data.data);
        setEnderecoPedido(response.data.data);
      } else {
        console.warn('API [buscar_endereco_pedido] não retornou dados em .data');
        setEnderecoPedido({}); // Define como objeto vazio
      }
    } catch (error) {
      console.error('Erro ao carregar endereço do pedido:', error);
      addToast('Erro ao carregar endereço', 'error');
      setEnderecoPedido({});
    } finally {
      setCarregandoEndereco(false);
    }
  };

  // ... (abrirModal)
  // MODIFICADO: para ser 'async' e carregar dados *depois* de abrir
  const abrirModal = async (pedido) => {
    console.log('🔍 [DEBUG] abrirModal chamado com pedido:', pedido);
    setPedidoSelecionado(pedido);
    setModalAberta(true); // Abre o modal primeiro
    
    // Inicia os carregamentos
    await carregarProdutosPedido(pedido[2]);
    await carregarEnderecoPedido(pedido[2]);
    
    console.log('🔍 [DEBUG] Modal aberta e dados carregados');
  };

  // ... (fecharModal)
  const fecharModal = () => {
    setModalAberta(false);
    setPedidoSelecionado(null);
    setProdutosPedido([]);
    setEnderecoPedido({}); // Limpa o endereço
  };

  // ... (toggleFiltroStatus)
  const toggleFiltroStatus = (status) => {
    setStatusFiltros(prev => {
      if (prev.includes(status)) {
        return prev.filter(s => s !== status);
      } else {
        return [...prev, status];
      }
    });
  };

  // ... (handleMostrarTodosChange)
  const handleMostrarTodosChange = (e) => {
    const isChecked = e.target.checked;
    setMostrarTodos(isChecked);
    if (isChecked) {
      setStatusFiltros([...statusOptions]);
    } else {
      setStatusFiltros(['aguardando']);
    }
  };

  // ... (formatPrice, formatDate)
  const formatPrice = (price) => {
    if (price === undefined || price === null || price === '') return 'R$ 0,00';
    if (typeof price === 'string') {
      const numericPrice = parseFloat(price.replace(',', '.'));
      if (isNaN(numericPrice)) return 'R$ 0,00';
      return numericPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    if (typeof price === 'number' && !isNaN(price)) {
      return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    return 'R$ 0,00';
  };
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };
  
  // Esta função é para o LABEL (permanece a mesma)
  const getStatusLabel = (status) => {
    switch (status?.toLowerCase()) {
      case 'aguardando': return 'Aguardando';
      case 'concluido': return 'Concluído';  
      //case 'entregue': return 'Entregue';
      case 'cancelado': return 'Cancelado';
      case 'processando': return 'Processando';
      case 'enviado': return 'Enviado';
      default: return status || 'Desconhecido';
    }
  };

  // Esta função retorna o objeto de estilo para o background-color do CARD
  const getCardBackgroundColor = (status) => {
    const lowerStatus = status?.toLowerCase();

    switch (lowerStatus) {
      case 'aguardando':
        return { backgroundColor: '#fdfd96' };
      case 'cancelado':
        return { backgroundColor: '#FFD1D1' };
      case 'processando':
        return { backgroundColor: '#CCDEFF' };
      case 'enviado':
        return { backgroundColor: '#EADFFF' };
      //case 'entregue':
      case 'concluido':
        return { backgroundColor: '#F5F5F5' };
      default:
        return {}; 
    }
  };


  if (loading) {
    return <ModernLoader message="Carregando pedidos da loja..." />;
  }

  return (
    <ModernLayout title="Gerenciar Pedidos" showBackButton>
      <div className="container">
        
        {/* --- ESTRUTURA DE LAYOUT MODIFICADA --- */}
        <div className="row"> {/* Row Principal (Nova) */}
          
          {/* --- Coluna da Legenda (Nova) --- */}
          <div className="col-lg-3 d-none d-lg-block">
            <div className="sticky-top" style={{ top: '80px' }}>
              <div className="modern-card">
                <div className="card-header">
                  <h6 className="mb-0">
                    <i className="bi bi-palette me-2"></i>
                    Legenda
                  </h6>
                </div>
                <div className="card-body">
                  {legendaItens.map(item => (
                    <div key={item.status} className="d-flex align-items-center mb-2">
                      <div style={{
                        width: '25px',
                        height: '25px',
                        borderRadius: '4px',
                        border: '1px solid #eee',
                        ...getCardBackgroundColor(item.status)
                      }} className="me-3"></div>
                      <span>{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* --- Coluna de Conteúdo (Original, agora em col-lg-9) --- */}
          <div className="col-lg-9">
            <div className="row">
              <div className="col-12">
                {/* Filtros */}
                <div className="modern-card mb-4">
                  <div className="card-header">
                    <h6 className="mb-0">
                      <i className="bi bi-funnel me-2"></i>
                      Filtros
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row g-3">
                      <div className="col-auto">
                        <span className="fw-medium text-muted">Status:</span>
                      </div>
                      {statusOptions.map(status => (
                        <div key={status} className="col-auto">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`status-${status}`}
                              checked={statusFiltros.includes(status)}
                              onChange={() => toggleFiltroStatus(status)}
                            />
                            <label className="form-check-label text-capitalize" htmlFor={`status-${status}`}>
                              {status}
                            </label>
                          </div>
                        </div>
                      ))}
                      <div className="col-auto">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="mostrar-todos"
                            checked={mostrarTodos}
                            onChange={handleMostrarTodosChange}
                          />
                          <label className="form-check-label" htmlFor="mostrar-todos">
                            Mostrar todos
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Lista de Pedidos (lógica original) */}
                {pedidos.length === 0 ? (
                  // Estado vazio
                  <div className="text-center py-5">
                    <i className="bi bi-clipboard-x fs-1 text-muted mb-3"></i>
                    <h4>Nenhum pedido encontrado</h4>
                    <p className="text-muted mb-4">
                      Não há pedidos com os filtros selecionados.
                    </p>
                  </div>
                ) : (
                  // Lista de pedidos
                  <div className="row g-4">
                    {pedidos.map((pedido, index) => {
                      return (
                        <div key={index} className="col-12">
                        <div 
                          className="modern-card"
                          style={getCardBackgroundColor(pedido[4])}
                        >
                          <div className="card-header d-flex justify-content-between align-items-start">
                            <div>
                              <h6 className="mb-1">
                                <i className="bi bi-receipt me-2"></i>
                                Pedido #{pedido[2]}
                              </h6>
                              <p className="text-muted mb-1">
                                <i className="bi bi-person me-1"></i>
                                Cliente: {pedido[0]}
                              </p>
                              <small className="text-muted">
                                <i className="bi bi-calendar me-1"></i>
                                {formatDate(pedido[1])}
                              </small>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                              <div className="text-end">
                                <h6 className="mb-0">
                                  Total: {formatPrice(pedido[3])}
                                </h6>
                              </div>
                            </div>
                          </div>
                          
                          <div className="card-body">
                            <div className="d-flex gap-2 flex-wrap">
                              {/* MODIFICADO: Botão limpo, sem debug */}
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => abrirModal(pedido)}
                              >
                                <i className="bi bi-eye me-1"></i>
                                Ver Detalhes
                              </button>
                              
                              <select
                                value={pedido[3]}
                                onChange={(e) => atualizarStatusPedido(pedido[2], e.target.value)}
                                className="form-select form-select-sm text-capitalize"
                                style={{ width: 'auto' }}
                              >
                                {statusOptions.map(status => (
                                  <option key={status} value={status} className="text-capitalize">
                                    {getStatusLabel(status)}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div> {/* Fim da col-lg-9 (Conteúdo) */}

          </div>
          {/* --- FIM DA ESTRUTURA MODIFICADA --- */}
        </div>
        

        {/* Modal de detalhes do pedido (sem alteração, permanece fora da estrutura de colunas) */}
        {modalAberta && (
          <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="bi bi-receipt me-2"></i>
                    Detalhes do Pedido #{pedidoSelecionado?.[2]}
                  </h5>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={fecharModal}
                  ></button>
                </div>
                <div className="modal-body">
                  {carregandoEndereco ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                      <p className="mt-2 text-muted">Carregando Dados do cliente...</p>
                    </div>
                  ) : (
                    <div className="row g-3">
                      {/* Cliente */}
                        <div className="col-12">
                          <div className="d-flex mt-5 align-items-center p-3 bg-light shadow-sm rounded">
                            <h5>Cliente</h5>
                          </div>
                          <div className="d-flex align-items-center p-3 bg-light-subtle shadow-sm rounded">
                            <div className="flex-fill">
                              <p className="text-muted mb-1"><b className='mx-1'>Nome: </b> {enderecoPedido.nome_completo}</p>
                              <p className="text-muted mb-1"><b className='mx-1'>E-mail: </b> {enderecoPedido.email}</p>
                              <p className="text-muted mb-1"><b className='mx-1'>Telefone: </b> {enderecoPedido.telefone}</p>
                              <p className="text-muted mb-0"><b className='mx-1'>Endereço: </b> {enderecoPedido.endereco_formatado}</p>
                              <p className="text-muted mb-0"><b className='mx-1'>CEP: </b> {enderecoPedido.cep}</p>
                              <p className="text-muted mb-0"><b className='mx-1'>Cidade: </b> {enderecoPedido.cidade}</p>
                              <p className="text-muted mb-0"><b className='mx-1'>Data do Pedido: </b> {formatDate(enderecoPedido.data_criacao)}</p>
                            </div>
                          </div>
                        </div>
                    </div>
                    
                  )}
                  {carregandoProdutos ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                      <p className="mt-2 text-muted">Carregando produtos...</p>
                    </div>
                  ) : (
                    // --- CÁLCULO E JSX DOS PRODUTOS E TOTAL ---
                    // Envolvemos o retorno em uma IIFE (Função Imediatamente Invocada)
                    // para poder calcular o 'totalPedido' antes de usá-lo.
                    (() => {
                      // --- NOVO: CÁLCULO DO TOTAL ---
                      const totalPedido = Array.isArray(produtosPedido) ? produtosPedido.reduce((totalAcumulado, produto) => {
                          // produto[2] = Quantidade, produto[3] = Preço
                          const quantidade = parseFloat(produto[2]) || 0;
                          const preco = parseFloat(produto[3]) || 0;
                          return totalAcumulado + (quantidade * preco);
                      }, 0) : 0; // O '0' é o valor inicial do totalAcumulado

                      // Retorna o JSX dos produtos e do total
                      return (
                        <div className="row g-3">
                          {/* Produtos */}
                          <div className="col-12">
                            <div className="d-flex mt-5 align-items-center p-3 bg-light shadow-sm rounded">
                              <h5>Produtos</h5>
                            </div>
                            {/* Verificação de segurança adicionada */}
                            {Array.isArray(produtosPedido) && produtosPedido.length > 0 ? (
                              produtosPedido.map((produto, index) => (
                                <div key={index} className="col-12">
                                  <div className="d-flex align-items-center p-3 bg-light-subtle shadow-sm rounded">
                                    <img
                                      src={produto[1]}
                                      alt={produto[0]}
                                      className="rounded me-3"
                                      style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                      onError={(e) => {
                                        e.target.src = 'https://via.placeholder.com/60x60/e5e7eb/9ca3af?text=Img';
                                      }}
                                    />
                                    <div className="flex-fill">
                                      <h6 className="mb-1">{produto[0]} - {produto[4]}</h6>
                                      <p className="text-muted mb-1">Quantidade: {produto[2]}</p>
                                      <p className="text-muted mb-0">Preço unitário: {formatPrice(produto[3])}</p>
                                    </div>
                                    <div className="text-end">
                                      <h6 className="text-success mb-0">
                                        {formatPrice(produto[3] * produto[2])}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="col-12 text-center p-3">
                                <p className="text-muted mb-0">Nenhum produto encontrado.</p>
                              </div>
                            )}

                            {/* --- DIV DO TOTAL MODIFICADA --- */}
                            <div className="d-flex mt-5 align-items-center justify-content-between p-3 bg-light shadow-sm rounded">
                              <h5 className="mb-0">Total:</h5>
                              <h4 className="mb-0 text-success fw-bold">
                                {formatPrice(totalPedido)}
                              </h4>
                            </div>
                            {/* --- FIM DA MODIFICAÇÃO --- */}

                          </div>
                        </div>
                      );
                    })() // Executa a função
                    // --- FIM DO BLOCO DE CÁLCULO ---
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </ModernLayout>
  );
}

export default ModernPedidosLoja;